import React, { FC, Fragment, ChangeEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Grid, Tabs, Typography } from '@material-ui/core';
import { createStyles, Theme, withStyles, lighten, WithStyles } from '@material-ui/core/styles';
import AddCircle from '@material-ui/icons/AddCircle';

import { ClientInvitationStatus } from 'api';
import { LargeTab } from 'components';
import { AdminPeopleInvite } from 'Links';

interface IProps extends WithStyles<typeof styles> {
  filter: string;
  total: number;
  checkedTotal: number;
  canResend: boolean;
  onChange: (value: ClientInvitationStatus) => void;
  onResend: () => void;
  onDelete: () => void;
}

const styles = (theme: Theme) =>
  createStyles({
    resendButton: {
      minWidth: 150,
      borderColor: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: lighten(theme.palette.primary.main, 0.9),
      },
    },
    deleteButton: {
      minWidth: 150,
      borderColor: theme.palette.error.main,
      '&:hover': {
        backgroundColor: lighten(theme.palette.error.main, 0.9),
      },
    },
  });

const Header: FC<IProps> = props => {
  const { classes, filter, onChange, onResend, onDelete, total, checkedTotal, canResend } = props;
  const { t } = useTranslation();

  function handleChange(event: ChangeEvent, value: ClientInvitationStatus) {
    onChange(value);
  }

  function renderTabs() {
    return (
      <Tabs value={filter} onChange={handleChange}>
        <LargeTab
          label={<Fragment>{t('common:pending')}</Fragment>}
          value={ClientInvitationStatus.Active}
        />
        <LargeTab
          label={<Fragment>{t('common:accepted')}</Fragment>}
          value={ClientInvitationStatus.Accepted}
        />
      </Tabs>
    );
  }

  function renderTotal() {
    return <Typography variant="subtitle2">{t('components:xPerson', { count: total })}</Typography>;
  }

  return (
    <Fragment>
      <Grid container alignItems="center">
        <Grid item xs>
          <Grid container alignItems="center" spacing={2}>
            <Grid item>{renderTabs()}</Grid>
            {canResend && (
              <Grid item>
                <Button variant="outlined" className={classes.resendButton} onClick={onResend}>
                  {t('admin:resendInvite', { count: checkedTotal })}
                </Button>
              </Grid>
            )}
            {!!checkedTotal && (
              <Grid item>
                <Button variant="outlined" className={classes.deleteButton} onClick={onDelete}>
                  {t('common:delete')}
                </Button>
              </Grid>
            )}
          </Grid>
        </Grid>
        <Grid item>
          <Grid container alignItems="center" justify="flex-end" spacing={3}>
            <Grid item>{!!total && renderTotal()}</Grid>
            <Grid item>
              <Button
                variant="contained"
                color="primary"
                component={AdminPeopleInvite}
                startIcon={<AddCircle />}
              >
                {t('admin:invitePeople')}
              </Button>
            </Grid>
            <Grid item />
          </Grid>
        </Grid>
      </Grid>
    </Fragment>
  );
};

export default withStyles(styles)(Header);
